<template>
    <div class="header-container">
        <img src="/static/image/ic_area_header.png"/>
        <span class="title">{{title}}</span>
        <a class="right" v-if="rightText.length > 0 " @click="rightClick">{{rightText}}</a>
    </div>
</template>

<script>
export default {
    props:{
        title:'',
        rightText:{
          type:String,
          default:'',
          required:false
        }
    },
     methods:{
      rightClick(){
        this.$emit("rightClick")
      }
    }
}
</script>

<style scoped>
.header-container{
    width: 100%;
    height: 41px;
    display: flex;
    flex-direction: row;
    align-items: center;
    background: #F7F7F7;
}
.header-container>img{
    width: 171px;
    height: 41px;
}
.header-container>span{
    color: white;
    font-size: 20px;
    position: relative;
    right: 151px;
}
.title{
    color: white;
    font-size: 20px;
    position: relative;
    right: 151px;
}
.right{
  color: red;
  font-size: 18px;
  cursor: pointer;
}
</style>